import { render, staticRenderFns } from "./code-block.vue?vue&type=template&id=4bba43d0&scoped=true&"
import script from "./code-block.vue?vue&type=script&lang=js&"
export * from "./code-block.vue?vue&type=script&lang=js&"
import style0 from "./code-block.vue?vue&type=style&index=0&id=4bba43d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba43d0",
  null
  
)

export default component.exports